/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "react-js-pagination";
import * as Yup from "yup";
import API from "../../API";
import { ShowContext } from "../../App";
import FormField from "../../utils/FormField";
import { uploadFileToS3UsingSignedURL } from "../../utils/Helper";

const MenuTabs = () => {
    // `id`, `pageUrl`, `pageTitle`, `inLinkTitle`, `inLink`, `pdfUrl`, `status`, 
    const myInitialValues = {
        pageUrl: "",
        pageTitle: "",
        inLinkTitle: "",
        inLink: "",
        pdfUrl: "",
        status: "",
    };

    const { setShow, setMsg } = useContext(ShowContext);

    const header = [
        { text: "Sr.No.", dataField: "srno" },
        { text: "Page Url", dataField: "pageUrl" },
        { text: "Page Title", dataField: "pageTitle" },
        { text: "Inner Link Title", dataField: "inLinkTitle" },
        { text: "Inner Link", dataField: "inLink" },
        { text: "PDF Url", dataField: "pdfUrl" },
        { text: "Modify", dataField: "edit" },
        { text: "Status", dataField: "status" },
    ];

    const types = ["PDF", "URL"];

    const validationSchema = Yup.object({
        pageUrl: Yup.string().required("Page URL is required"),
        pageTitle: Yup.string().required("Page Title is required"),
        type: Yup.string().required("Type is required"),
        pdfUrl: Yup.mixed().required("PDF is required"),
    });

    const [list, setList] = useState();
    const [data, setData] = useState();

    const [editData, setEditData] = useState();

    const [curPage, setCurPage] = useState(0);
    const [perPage, setPerPage] = useState(0);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        if (list) {
            setCurPage(list.current_page);
            setPerPage(list.per_page);
            setTotal(list.total);

            getData(list.data);
        }
    }, [list]);

    useEffect(() => {
        getRegionalOffices(1);
    }, []);

    return (
        <div className="py-1">
            <div className="card">
                <div className="card-body">
                    <h3>
                        <center>Dynamic Menu Pages </center>
                    </h3>
                    <Formik
                        initialValues={editData ? editData : myInitialValues}
                        enableReinitialize={true}
                        validationSchema={!editData && validationSchema}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            if (editData) {
                                updateData(values, setSubmitting, resetForm);
                            } else {
                                addData(values, setSubmitting, resetForm);
                            }
                        }}
                    >
                        {({ values, handleChange, setFieldValue, isSubmitting, errors }) => (
                            <Form>
                                {Object.keys(errors).length > 0 && <div className="alert alert-danger">
                                    {Object.keys(errors).slice(0, 1).map((key) => (
                                        <div key={key}>{errors[key]}</div>
                                    ))}
                                </div>}
                                <div className="row">
                                    <div className="col-sm-6">
                                        <FormField name="pageUrl" heading="Page Url" />
                                        <div class="alert alert-primary p-1">
                                            If your Page Url is <strong>'my-url'</strong>, it will create a route like <strong>'/menu/my-url'</strong>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <FormField name="pageTitle" heading="Page Title" />
                                    </div>
                                    <div className="col-sm-6">
                                        <FormField name="inLinkTitle" heading="Inner Link Title" />
                                    </div>
                                    <div className="col-sm-6">
                                        <FormField name="inLink" heading="Inner Link" />
                                    </div>
                                    <div className="col-sm-6">
                                        <FormField
                                            values={values}
                                            name="type"
                                            heading="Select Type"
                                            as="select"
                                            options={types?.map((item, i) => (
                                                <option key={i} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        />
                                    </div>
                                    {values.type == "URL" && <div className="col-sm-6">
                                        <FormField name="pdfUrl" heading="PDF URL" />
                                    </div>}
                                    {values.type == "PDF" && <div className="col-sm-6">
                                        <FormField
                                            name="pdfUrl"
                                            type="file"
                                            heading="Upload PDF"
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            accept="application/pdf"
                                        />
                                    </div>}

                                </div>

                                <div className="text-center py-3">
                                    <button
                                        type="submit"
                                        className="btn btn-primary mx-2"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                &nbsp;Submitting...
                                            </>
                                        ) : (
                                            "Submit"
                                        )}
                                    </button>
                                    {editData && (
                                        <button
                                            type="button"
                                            className="btn btn-danger mx-2"
                                            onClick={(e) => setEditData()}
                                            disabled={isSubmitting}
                                        >
                                            Cancel
                                        </button>
                                    )}
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
            <div className="card my-3">
                <div className="card-body">
                    <div className="m-3">
                        {data && data?.length > 0 && (
                            <BootstrapTable
                                data={data}
                                columns={header}
                                keyField="srno"
                                headerClasses="allTable_header text-center"
                            />
                        )}
                    </div>
                    {data && data?.length > 0 && <div
                        className="mt-1 d-flex justify-content-around">
                        <Pagination
                            totalItemsCount={total}
                            activePage={curPage}
                            itemsCountPerPage={perPage}
                            onChange={(pageNumber) => {
                                setCurPage(pageNumber);
                                getRegionalOffices(pageNumber);
                            }}
                            itemClass="page-item"
                            linkClass="page-link"
                            firstPageText="First"
                            lastPageText="Last"
                        />
                    </div>}
                </div>
            </div>
        </div>
    );

    function getData(params) {
        setData(
            params.map((item, i) => {
                return {
                    ...item,
                    srno: i + 1,
                    pageUrl: <a href={process.env.REACT_APP_SITE_URL + '/menu/' + item.pageUrl} className="text-break" target="_blank" rel="noreferrer">
                        {process.env.REACT_APP_SITE_URL + '/menu/' + item.pageUrl}
                    </a>,
                    inLink: <a href={item.inLink} className="text-break" target="_blank" rel="noreferrer">
                        {item.inLink}
                    </a>,
                    pdfUrl: <a href={item.pdfUrl} className="text-break" target="_blank" rel="noreferrer">
                        {item.pdfUrl}
                    </a>,
                    edit: (
                        <button
                            className="btn btn-warning"
                            onClick={() => setEditData(item)}
                        >
                            Modify
                        </button>
                    ),
                    status: (
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={item.status}
                                onChange={() => {
                                    updateStatus(item.id, item.status ? 0 : 1);
                                }}
                            />
                            <span className="slider round"></span>
                        </label>
                    ),
                };
            })
        );
    }

    async function getRegionalOffices(page) {
        try {
            const res = await API.get("/menu-page", { params: { page } });
            setList(res.data?.data);
            // show({message: data.message, displayClass: data.status })
        } catch (error) {
            setShow(true);
            setMsg(error.response.data.message);
        }
    }

    async function updateData(values, setSubmitting, resetForm) {
        try {
            if (values.pdfUrl instanceof File) {
                values.pdfUrl = await uploadFileToS3UsingSignedURL(values.pdfUrl, "menuPagesPDFs");
            }

            const res = await API.put("/menu-page", values);
            setList((pre) => ({
                ...pre,
                data: pre.data.map((rec) => {
                    if (rec.id != values.id) {
                        return rec;
                    } else {
                        return { ...rec, ...res.data.data };
                    }
                }),
            }));
            setEditData();
            resetForm();
            setShow(true);
            setMsg(data.message);
            setSubmitting(false);
        } catch (error) {
            setSubmitting(false);
            setShow(true);
            setMsg(error.response.data.message);
        }
    }
    async function addData(values, setSubmitting, resetForm) {
        try {
            if (values.pdfUrl instanceof File) {
                values.pdfUrl = await uploadFileToS3UsingSignedURL(values.pdfUrl, "menuPagesPDFs");
            }
            const res = await API.post("/menu-page", values);
            resetForm();
            setList((pre) => ({
                ...pre,
                data: [...pre.data, res.data.data],
            }));
            setSubmitting(false);
        } catch (error) {
            resetForm();
            setSubmitting(false);
            setShow(true);
            setMsg(error.response.data.message);
        }
    }

    async function updateStatus(id, status) {
        await API.post("/menu-page/disable", { id: id, status: status })
            .then((res) => {
                if (res.data.status === "success") {
                    setList((pre) => ({
                        ...pre,
                        data: pre.data.map((rec) => {
                            if (rec.id != id) {
                                return rec;
                            } else {
                                return { ...rec, status: parseInt(rec.status) ? 0 : 1 };
                            }
                        }),
                    }));
                    setShow(true);
                    setMsg(res.data.message);
                }
            })
            .catch((error) => {
                setShow(true);
                setMsg(error.response.data.message);
            });
    }
};

export default MenuTabs;
